<template>
  <div id="login-form">
    <Form
      :header="header"
      :model="model"
      :schema="schema"
      :options="options"
      :buttons="buttons"
      :messages="messages"
      @form_submit="form_submit"
      @button_click="button_click"></Form>
  </div>
</template>

<script>
import Vue from "vue";
import Form from "../../components/Form.vue";
import VueFormGenerator from "vue-form-generator";
import { get_validator_messages } from "../../validators/locale_pl";
import { AUTH_ACTIONS, LOCAL_STORAGE } from "../../utils/consts";

var validator_messages = get_validator_messages();

export default {
  name: "Login",
  components: {
    Form
  },
  computed: {
    validation_email: function () {
      if (this.form.errors.email.length > 0) {
        return false;
      } else {
        return null;
      }
    }
  },
  data() {
    return {
      buttons: [
        {
          name: "login",
          style_classes: "float-right mb-1",
          buttons: [
            {
              label: "Nie mam konta",
              variant: "primary",
              type: "button",
              name: "user-registration",
              icon: "person-plus-fill",
              id: "user-registration"
            },
            {
              label: "Zaloguj się",
              variant: "success",
              type: "submit",
              name: "login",
              icon: "shield-lock-fill",
              id: "login",
              spinner: true,
              spinner_id: "login-spinner"
            }
          ]
        },
        {
          name: "other",
          style_classes: "float-right btn-group-sm mt-1",
          buttons: [
            {
              label: "Przypomnienie hasła",
              variant: "info",
              type: "button",
              name: "password-reset",
              icon: "lock-fill",
              id: "password-reset"
            },
            {
              label: "Potwierdź konto",
              variant: "primary",
              type: "button",
              name: "confirm-registration",
              icon: "person-check-fill",
              id: "confirm-registration"
            }
          ]
        }
      ],
      header: {
        title: "Logowanie",
        icon: "shield-lock-fill"
      },
      model: {
        email: null,
        password: null
      },
      messages: [],
      options: {
        validateAsync: true
      },
      schema: {
        groups: [
          {
            styleClasses: "form-row",
            fields: [
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "email",
                label: "Email",
                model: "email",
                required: true,
                validator: [
                  VueFormGenerator.validators.email.locale(validator_messages)
                ]
              },
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "password",
                label: "Hasło",
                model: "password",
                required: true,
                autocomplete: true,
                validator: [
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              }
            ]
          }
        ]
      }
    };
  },
  methods: {
    // This method is run when login form is submited
    // It gets model with all form data on it
    disable_buttons: function (should_disable) {
      const button_login = document.getElementById("login");
      button_login.disabled = should_disable;
      const button_user_registration =
        document.getElementById("user-registration");
      button_user_registration.disabled = should_disable;
      const button_password_reset = document.getElementById("password-reset");
      button_password_reset.disabled = should_disable;
      const confirm_registration = document.getElementById(
        "confirm-registration"
      );
      confirm_registration.disabled = should_disable;
    },

    form_submit: function (model) {
      this.disable_buttons(true);
      const download_spinner = document.getElementById("login-spinner");
      download_spinner.style.display = "block";
      Vue.CognitoAuth.sign_in(
        {
          username: model.email,
          password: model.password
        },
        this.login_success,
        this.login_failure
      );
    },
    login_success: function (result) {
      this.messages = [];
      var $this = this;
      Vue.CognitoAuth.get_current_user_data().then(function (user_data) {
        let merged_data = { ...result.data.data, ...user_data };
        $this.$store.commit("user_login", merged_data);
        if (user_data.is_proxy === "true") {
          $this.$router.push({ name: "ProxyManage" });
        } else {
          $this.$router.push("/");
        }
      });
    },
    login_failure: function (err) {
      this.disable_buttons(false);
      const download_spinner = document.getElementById("login-spinner");
      download_spinner.style.display = "None";
      if (err == "User is not confirmed") {
        Vue.CognitoAuth.resend_verification_code(
          {
            username: this.model.email
          },
          this.resend_verification_code_success,
          this.resend_verification_code_failure
        );
        this.$localStorage.set("confirm_email", this.model.email);
        this.$router.push({ name: "ConfirmRegistration" });
      }
      console.log("login failure:", err);
      this.messages = [];
      this.messages.push({
        label: err,
        variant: "danger"
      });
    },
    button_click: function (button_name) {
      switch (button_name) {
        case "confirm-registration":
          this.$router.push({ name: "ConfirmRegistration" });
          break;
        case "password-reset":
          this.$router.push({ name: "PasswordReset" });
          break;
        case "user-registration":
          this.$router.push({ name: "UserRegistration" });
          break;
      }
    }
  },
  mounted() {
    // Method displays certain messages based on previous executed auth action
    this.$nextTick(function () {
      const params = new URLSearchParams(document.location.search);
      const paymentRedirect = params.get("paymentRedirect");

      if (paymentRedirect) {
        this.messages = [
          {
            variant: "primary",
            label:
              "Jeśli transakcja przebiegła pomyślnie, na podany adres email otrzymasz wiadomość z kodem aktywacyjnym oraz dalszą instrukcją rejestracji konta."
          }
        ];
      } else {
        const previousAuthAction = this.$localStorage.get(
          LOCAL_STORAGE.executed_auth_action
        );

        switch (previousAuthAction) {
          case AUTH_ACTIONS.account_activation:
            this.messages = [
              {
                variant: "success",
                label: "Twój adres email został zweryfikowany prawidłowo."
              },
              {
                variant: "primary",
                label: "Możesz się zalogować."
              }
            ];
            this.model.email = this.$localStorage.get(
              LOCAL_STORAGE.activated_account_email
            );
            this.$localStorage.remove(LOCAL_STORAGE.activated_account_email);
            break;
          case AUTH_ACTIONS.password_reset:
            this.messages = [
              {
                variant: "success",
                label: "Możesz się zalogować używając nowego hasła."
              }
            ];
        }
        this.$localStorage.remove(LOCAL_STORAGE.executed_auth_action);
      }
    });
  }
};
</script>

<style>
@media (min-width: 768px) {
  #login-form .form-container {
    max-width: 520px;
  }
}
</style>
